/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarStatsPublic,
  PieChartStats,
  PublicHangarStatsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Public Hangar Stats
 */
export const publicHangarStats = (
    username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarStatsParams>,
 signal?: AbortSignal
) => {
      username = toValue(username);
params = toValue(params);

      return axiosClient<HangarStatsPublic>(
      {url: `/public/hangars/${username}/stats`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicHangarStatsQueryKey = (username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarStatsParams>,) => {
    return [
    'public','hangars',username,'stats', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicHangarStatsQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarStatsQueryKey(username,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarStats>>> = ({ signal }) => publicHangarStats(username,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarStats>>, TError, TData>
}

export type PublicHangarStatsQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarStats>>>
export type PublicHangarStatsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Hangar Stats
 */

export function usePublicHangarStats<TData = Awaited<ReturnType<typeof publicHangarStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicHangarStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarStatsQueryOptions(username,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Hangar Models by Classification
 */
export const publicHangarModelsByClassification = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<PieChartStats[]>(
      {url: `/public/hangars/${username}/stats/models-by-classification`, method: 'GET', signal
    },
      );
    }




export const getPublicHangarModelsByClassificationQueryKey = (username: MaybeRefOrGetter<string>,) => {
    return [
    'public','hangars',username,'stats','models-by-classification'
    ] as const;
    }


export const getPublicHangarModelsByClassificationQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarModelsByClassification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByClassification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarModelsByClassificationQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarModelsByClassification>>> = ({ signal }) => publicHangarModelsByClassification(username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByClassification>>, TError, TData>
}

export type PublicHangarModelsByClassificationQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarModelsByClassification>>>
export type PublicHangarModelsByClassificationQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Hangar Models by Classification
 */

export function usePublicHangarModelsByClassification<TData = Awaited<ReturnType<typeof publicHangarModelsByClassification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByClassification>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarModelsByClassificationQueryOptions(username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Hangar Models by Manufacturer
 */
export const publicHangarModelsByManufacturer = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<PieChartStats[]>(
      {url: `/public/hangars/${username}/stats/models-by-manufacturer`, method: 'GET', signal
    },
      );
    }




export const getPublicHangarModelsByManufacturerQueryKey = (username: MaybeRefOrGetter<string>,) => {
    return [
    'public','hangars',username,'stats','models-by-manufacturer'
    ] as const;
    }


export const getPublicHangarModelsByManufacturerQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarModelsByManufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByManufacturer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarModelsByManufacturerQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarModelsByManufacturer>>> = ({ signal }) => publicHangarModelsByManufacturer(username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByManufacturer>>, TError, TData>
}

export type PublicHangarModelsByManufacturerQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarModelsByManufacturer>>>
export type PublicHangarModelsByManufacturerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Hangar Models by Manufacturer
 */

export function usePublicHangarModelsByManufacturer<TData = Awaited<ReturnType<typeof publicHangarModelsByManufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByManufacturer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarModelsByManufacturerQueryOptions(username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Hangar Models by Production Status
 */
export const publicHangarModelsByProductionStatus = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<PieChartStats[]>(
      {url: `/public/hangars/${username}/stats/models-by-production-status`, method: 'GET', signal
    },
      );
    }




export const getPublicHangarModelsByProductionStatusQueryKey = (username: MaybeRefOrGetter<string>,) => {
    return [
    'public','hangars',username,'stats','models-by-production-status'
    ] as const;
    }


export const getPublicHangarModelsByProductionStatusQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarModelsByProductionStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByProductionStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarModelsByProductionStatusQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarModelsByProductionStatus>>> = ({ signal }) => publicHangarModelsByProductionStatus(username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByProductionStatus>>, TError, TData>
}

export type PublicHangarModelsByProductionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarModelsByProductionStatus>>>
export type PublicHangarModelsByProductionStatusQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Hangar Models by Production Status
 */

export function usePublicHangarModelsByProductionStatus<TData = Awaited<ReturnType<typeof publicHangarModelsByProductionStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsByProductionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarModelsByProductionStatusQueryOptions(username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Hangar Models by Size
 */
export const publicHangarModelsBySize = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<PieChartStats[]>(
      {url: `/public/hangars/${username}/stats/models-by-size`, method: 'GET', signal
    },
      );
    }




export const getPublicHangarModelsBySizeQueryKey = (username: MaybeRefOrGetter<string>,) => {
    return [
    'public','hangars',username,'stats','models-by-size'
    ] as const;
    }


export const getPublicHangarModelsBySizeQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarModelsBySize>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsBySize>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarModelsBySizeQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarModelsBySize>>> = ({ signal }) => publicHangarModelsBySize(username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsBySize>>, TError, TData>
}

export type PublicHangarModelsBySizeQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarModelsBySize>>>
export type PublicHangarModelsBySizeQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Hangar Models by Size
 */

export function usePublicHangarModelsBySize<TData = Awaited<ReturnType<typeof publicHangarModelsBySize>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarModelsBySize>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarModelsBySizeQueryOptions(username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






